interface Role {
  id: string;
  roleCode: RoleCode;
}

type RoleCode =
  | 'stress_check_practitioner'
  | 'stress_check_person_in_charge'
  | 'regular_health_checkup_user'
  | 'user_manager';

export interface Roles<Default = null> {
  stressCheckRole: RoleCode | Default;
  healthCheckRole: RoleCode | Default;
  userManageRole: RoleCode | Default;
}

export const extractRoles = <Default = null>(roles: Role[], defaultValue: Default): Roles<Default> => {
  let stressCheckRole: RoleCode | Default = defaultValue;
  let healthCheckRole: RoleCode | Default = defaultValue;
  let userManageRole: RoleCode | Default = defaultValue;

  for (const role of roles) {
    switch (role.roleCode) {
      case 'stress_check_practitioner':
        stressCheckRole = role.roleCode;
        break;
      case 'stress_check_person_in_charge':
        stressCheckRole = role.roleCode;
        break;
      case 'regular_health_checkup_user':
        healthCheckRole = role.roleCode;
        break;
      case 'user_manager':
        userManageRole = role.roleCode;
        break;
    }
  }

  return {
    stressCheckRole,
    healthCheckRole,
    userManageRole
  };
};
